const dayNow = () => new Date().toISOString().slice(0,10);
const storageKey = (account, day) => `amposter:tasbeeh:goal-decisions:${account}:${day}`;
const keyFor = (scope, dhikr, goal, version) => JSON.stringify([scope, scope === 'dhikr' ? dhikr : '', goal, version || 0]);
const sessionDecisions = new Map();

function decisions(account, day) {
  const key = storageKey(account,day);
  try { return JSON.parse(localStorage.getItem(key) || '{}'); }
  catch { return sessionDecisions.get(key) || {}; }
}

export function reachedTasbeehGoals(account, dhikr, view, day = dayNow()) {
  if (!account || account === 'guest') return [];
  const accepted = decisions(account,day), reached = [];
  const add = (scope, count, goal, version) => {
    if (!goal || count < goal) return;
    const key = keyFor(scope,dhikr,goal,version);
    if (!accepted[key]) reached.push({ key, scope, goal, count, dhikr, day, version:version || 0 });
  };
  add('dhikr',view.dhikrTodayCount,view.dhikrGoal,view.dhikrGoalUpdatedAt);
  add('daily',view.todayCount,view.goal,view.goalUpdatedAt);
  return reached;
}

export function acknowledgeTasbeehGoals(account, goals, continuing = true) {
  for (const goal of goals) {
    // Choosing another dhikr permits further overall progress, but does not
    // silently permit extra repetitions of the completed individual dhikr.
    if (!continuing && goal.scope === 'dhikr') continue;
    const key = storageKey(account,goal.day), value = { ...decisions(account,goal.day), [goal.key]:true };
    sessionDecisions.set(key,value);
    try { localStorage.setItem(key,JSON.stringify(value)); } catch { /* Keep the choice for this session. */ }
  }
}

export function tasbeehGoalReachedError(goals) {
  return Object.assign(new Error('Choose how to continue after reaching your goal'),{ code:'TASBEEH_GOAL_REACHED', goals });
}
